import { render, staticRenderFns } from "./belongCell.vue?vue&type=template&id=540dff22&scoped=true"
import script from "./belongCell.vue?vue&type=script&lang=js"
export * from "./belongCell.vue?vue&type=script&lang=js"
import style0 from "./belongCell.vue?vue&type=style&index=0&id=540dff22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540dff22",
  null
  
)

export default component.exports